import React from 'react'

import { Checkbox } from '@/components/atoms/Checkbox/Checkbox.tsx'
import { Input } from '@/components/atoms/Input/Input.tsx'
import {
  ConfirmDialog,
  type ConfirmDialogLabels,
  type ConfirmDialogState,
} from '@/components/molecules/ConfirmDialog/ConfirmDialog.tsx'

export interface ConfirmDonationDialogLabels extends ConfirmDialogLabels {
  receipt: string
}

export interface ConfirmDonationDialogState extends ConfirmDialogState {}

export interface ConfirmDonationDialogData {
  teamNumber?: string
}

export interface ConfirmDonationDialogAction {
  onConfirm: (value: { value: number; hasReceipt: boolean }) => void
}

export interface ConfirmDonationDialogProps
  extends
    React.HtmlHTMLAttributes<HTMLDivElement>,
    ConfirmDonationDialogData,
    ConfirmDonationDialogState,
    ConfirmDonationDialogAction {
  labels: ConfirmDonationDialogLabels
}

export const ConfirmDonationDialog = React.forwardRef<HTMLDivElement, ConfirmDonationDialogProps>(
  ({ labels, onConfirm, ...props }, ref) => {
    const [state, setState] = React.useState({
      donation: '',
      hasReceipt: false,
    })

    return (
      <ConfirmDialog
        labels={labels}
        onOpenChange={(value) => {
          if (!value) setState({ donation: '', hasReceipt: false })
        }}
        onConfirmDisabled={!state.donation}
        onConfirm={() => {
          onConfirm({ value: Number(state.donation), hasReceipt: state.hasReceipt })
          setState({ donation: '', hasReceipt: false })
        }}
        {...props}
        ref={ref}>
        <div className="flex items-center gap-2.5">
          <Input
            type="number"
            step="0.01"
            min={0}
            className="w-44"
            value={state.donation}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setState((value) => ({ ...value, donation: event.target.value }))
            }}
          />
          <Checkbox
            id="receipt"
            checked={state.hasReceipt}
            onCheckedChange={(checked) => {
              setState((value) => ({ ...value, hasReceipt: !!checked }))
            }}
          />
          <label htmlFor="receipt" className="text-sm peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            {labels.receipt}
          </label>
        </div>
      </ConfirmDialog>
    )
  }
)
